import React from 'react'
import { Grid, makeStyles, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Icon from '../../../../atoms/Icon'
import PersonalSpace from '../../shared/PersonalSpace'
import SydInput from '../../../../commonDesign/SydInput'
import Loader from '../../Models/Loader'
import Tooltip from '../../../../atoms/Tooltip'
const useStyle = makeStyles((theme) => ({
  searchInput: {
    width: '100%',
    padding: '0px',
    background: 'var(--color-neutral-100)',
    border: 'none',
    borderTopLeftRadius: 'var(--border-radius-md)',
    borderTopRightRadius: 'var(--border-radius-md)',
    paddingLeft: '.5rem'
  },
  rowContainer: (props) => ({
    width: '100%',
    minWidth: 0,
    ...(props.editing && {
      '&:hover': {
        backgroundColor: 'var(--color-primary-500)',
        color: 'var(--color-contrast-primary-500)',
        cursor: 'pointer'
      }
    })
  }),
  activeRowContainer: (props) => ({
    backgroundColor: 'var(--color-neutral-200)',
    ...(props.editing && {
      '&:hover': {
        cursor: 'pointer'
      }
    })
  })
}))
const PermissionGroupBulkPermissions = ({ fullPermissionList, isSelected, selectPermission, unselectPermission, editing, search, setSearch, scrollRef, canEditInternalPermissions, userLoading, userType }) => {
  const classes = useStyle({ editing })
  const isAssignableMatch = (permission) => {
    if (userType === 1) {
      return permission.woAssignable === 1
    } else if (userType === 2) {
      return permission.advisorAssignable === 1
    }
    return false
  }
  return (
    <div
      className={clsx('flex flex-col items-center border border-black-300 w-1/2 sm:min-w-full radius-md')}
      ref={scrollRef}
      style={{ height: '80vh', overflow: 'scroll', minWidth: '665px' }}
    >
      <div className='flex flex-col items-center p-0 w-full'>
        <div className='w-full mb-xs flex justify-center' style={{ position: 'sticky', top: '0', backgroundColor: 'var(--color-white)' }}>
          <SydInput
            className={classes.searchInput}
            placeholder='Unassigned Permissions'
            size='sm'
            value={search}
            iconName='search'
            onChange={(e) => {
              if (scrollRef.current) {
                scrollRef.current.scrollTop = 0
              }
              setSearch(e.target.value)
            }}
          />
        </div>
        <Grid className='grid grid-cols-1 w-full'>
          {
            userLoading ? (
              <div className='flex flex-col items-center w-full'><Loader /></div>
            ) : (
              (fullPermissionList && fullPermissionList?.length > 0) && (
                fullPermissionList.map((item, index) => (
                  isAssignableMatch(item) && (
                    <Grid
                      item key={item.permissionId}
                      className={isSelected(item.permissionId) ? classes.activeRowContainer : classes.rowContainer}
                      onClick={() => {
                        (editing && canEditInternalPermissions(item)) && (
                          isSelected(item.permissionId)
                            ? unselectPermission(item.permissionId)
                            : selectPermission(item.permissionId)
                        )
                      }}
                    >
                      <div
                        className='flex pl-2 mr-4 gap-xs items-center justify-between'
                        style={{ wordBreak: 'break-word', boxSizing: 'border-box' }}
                      >
                        <div className='flex flex-col items-start gap-xs'>
                          <div className='flex items-center'>
                            <Typography>{item.name}</Typography>
                            {
                              !canEditInternalPermissions(item) ? (
                                <div className='ml-2'>
                                  <Tooltip
                                    placement='top'
                                    title={
                                      <div>
                                        <Typography variant='body2'>Permission does not default to Admins</Typography>
                                      </div>
                                    }
                                  >
                                    <div>
                                      <Icon name='warning' customColor='yellowOrange' customSize='24px' />
                                    </div>
                                  </Tooltip>
                                </div>
                              ) : (
                                !item?.defaultToAdmins && (
                                  <div className='ml-2'>
                                    <Tooltip
                                      placement='top'
                                      title={
                                        <div>
                                          <Typography variant='body2'>Internal Permission</Typography>
                                        </div>
                                      }
                                    >
                                      <div>
                                        <Icon name='warning' color='green' customSize='18px' />
                                      </div>
                                    </Tooltip>
                                  </div>
                                )
                              )
                            }
                          </div>
                          <Typography
                            variant='caption'
                            className='pl-4'
                          >
                            {item.description}
                          </Typography>
                        </div>
                        {
                          editing && (
                            !canEditInternalPermissions(item) ? (
                              <div>
                                <Icon name='lock' color='secondary' />
                              </div>
                            ) : (
                              isSelected(item.permissionId) ? (
                                <div>
                                  <Icon name='arrowBack' />
                                </div>
                              ) : (
                                <div>
                                  <Icon name='arrowForward' />
                                </div>
                              )
                            )
                          )
                        }
                      </div>
                    </Grid>
                  )
                ))
              )
            )
          }
        </Grid>
      </div>
      <PersonalSpace />
    </div>
  )
}

PermissionGroupBulkPermissions.propTypes = {
  fullPermissionList: PropTypes.array,
  isSelected: PropTypes.func,
  selectPermission: PropTypes.func,
  unselectPermission: PropTypes.func,
  editing: PropTypes.bool,
  search: PropTypes.string,
  setSearch: PropTypes.func,
  scrollRef: PropTypes.object,
  canEditInternalPermissions: PropTypes.func,
  userLoading: PropTypes.bool,
  userType: PropTypes.number
}

export default PermissionGroupBulkPermissions
